export default __webpack_public_path__ + "static/abajo-derecha-desk-a50e04a5fe11e80bc8a6730bdd48d805.png";